import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Drawer, Button, CircularProgress } from '@nextiva/next-ui-components';

import { SectionSaveCancelStyles } from './SectionSaveCancel.styles';

// used as a basic version of a finite state machine
const networkStates = {
  error: 'error',
  idle: 'idle',
  loading: 'loading',
  success: 'success',
};

export function SectionSaveCancel({
  cancelOnClick = () => {},
  open = false,
  saveOnClick = async () => {},
}) {
  const [networkState, setNetworkState] = useState(networkStates.idle);

  const saveHandler = async () => {
    try {
      setNetworkState(networkStates.loading);
      await saveOnClick();
      setNetworkState(networkStates.success);
    } catch (err) {
      setNetworkState(networkStates.error);
    } finally {
      setNetworkState(networkStates.idle);
    }
  };

  const cancelHandler = () => {
    setNetworkState(networkStates.idle);
    cancelOnClick();
  };

  return (
    <SectionSaveCancelStyles>
      <div className="section-save-cancel">
        <Drawer variant="persistent" anchor="bottom" open={open}>
          <div className="section-save-cancel__container">
            <div className="section-save-cancel__button-container">
              <Button
                className="section-save-cancel__button-container__button"
                id="sectionDrawerCancelBtn"
                variant="contained"
                color="secondary"
                onClick={cancelHandler}
                disabled={networkState === networkStates.loading}
                data-testid="PlatformAdminUI-TeamVoiceSettings-SectionSaveCancel-CancelButton"
              >
                Cancel
              </Button>
            </div>
            <div className="section-save-cancel__button-container">
              <Button
                className="section-save-cancel__button-container__button info"
                id="sectionDrawerSaveBtn"
                variant="contained"
                color="primary"
                onClick={saveHandler}
                disabled={networkState === networkStates.loading}
                data-testid="PlatformAdminUI-TeamVoiceSettings-SectionSaveCancel-SaveButton"
              >
                Save
              </Button>
              {networkState === networkStates.loading && (
                <span className="save-spinner">
                  <CircularProgress
                    data-testid="spinner"
                    style={{ color: '#009FE0' }}
                    mode="indeterminate"
                    size={36}
                  />
                </span>
              )}
            </div>
          </div>
        </Drawer>
      </div>
    </SectionSaveCancelStyles>
  );
}

SectionSaveCancel.propTypes = {
  cancelOnClick: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  saveOnClick: PropTypes.func.isRequired,
};
